import { useLogin } from "@sveabank/cc-common";
import { useFetchUserInfoQuery } from "../services/login";

export const useUser = () => {
	const { loginState } = useLogin();
	const { data, isSuccess, isLoading } = useFetchUserInfoQuery(undefined, {
		skip: loginState !== "LOGGED_IN",
	});

	const getLoggedInUser = () => {
		if (isSuccess) return data;

		throw new Error("not logged in");
	};

	return {
		user: data,
		getLoggedInUser,
		isSuccess,
		isLoading,
	};
};
